import React, { Component, Fragment, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, Stack } from "react-bootstrap";
import { getAreas, getMachines, getLines } from "./equipmentApi";
import { Link, useNavigate } from "react-router-dom";
import { resetSearch, setConfirmedMachine, setCurrentArea, setCurrentLine } from "./equiplmentSlice";
export function ManualEquipment(props) {
  const equipment = useSelector((state) => state.equipment)
  const dispatch = useDispatch()
  const login = useSelector((state) => state.login)
  let navigate = useNavigate();
  const [isFind, setIsFind] = useState(false)
  console.log(login)


  useEffect(() => {
    if (isFind) {

      return navigate("/anomaly");
    }
    if (!login.token) {
      return navigate("/login");
    }
  })

  let token = login.token
  let info = (
    <Fragment>

      <h2>Нет данных</h2>
      <Button variant="outline-secondary" onClick={() => dispatch(getLines(token))} className="ColorGray" >Повторить выбор </Button>
      <Button variant="outline-secondary" as={Link} to="/anomaly" className="ColorGray" >Вернуться к регистрации аномалии </Button>
    </Fragment>
  )

  function onFindMachine(machine) {
    dispatch(setConfirmedMachine(machine))
    dispatch(resetSearch())
    setIsFind(true)
  }
  function onFindArea(area){
    dispatch(setCurrentArea(area.name))
    dispatch(getMachines({ area: area.name, token: token }))
  }
  function onFindLine(line){
    dispatch(setCurrentLine(line.name))
    dispatch(getAreas({ line: line.name, token: token }))
  }

  if (equipment.machines.length > 0) {
    info = equipment.machines.map(machine => (<Button key={machine.id} variant="outline-dark" className="ColorGray" onClick={() => onFindMachine(machine)}>
      {machine.name}
    </Button>))
  }
  else if (equipment.areas.length > 0) {
    info = equipment.areas.map(area => (<Button key={area.id} variant="outline-dark" className="ColorGray" onClick={() => onFindArea(area)}>
      {area.name}
    </Button>))
  }
  else if (equipment.lines.length > 0) {

    info = equipment.lines.map(line => (<Button key={line.id} variant="outline-dark" className="ColorGray" onClick={() => onFindLine(line)}>
      {line.name}
    </Button>))
  }
  else {
    dispatch(getLines(token))
  }

  return (<Stack gap={3} className="col-md-6 mx-auto">
    {info}
  </Stack>);
}
